/**
 * @generated SignedSource<<45ee0e1a59ef1c51d17febd91308bfde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemGroupOptionsDeleteMutation$variables = {
  groupId: string;
};
export type ActionItemGroupOptionsDeleteMutation$data = {
  readonly deleteCustomActionItemGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly order: number;
    }> | null;
    readonly deletedGroupId: string | null;
  } | null;
};
export type ActionItemGroupOptionsDeleteMutation = {
  response: ActionItemGroupOptionsDeleteMutation$data;
  variables: ActionItemGroupOptionsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "groupId",
        "variableName": "groupId"
      }
    ],
    "concreteType": "DeleteCustomActionItemGroup",
    "kind": "LinkedField",
    "name": "deleteCustomActionItemGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedGroupId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupNode",
        "kind": "LinkedField",
        "name": "actionItemGroups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "order",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemGroupOptionsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemGroupOptionsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "97e5f60cdd972bfeac05a093f6c76ed8",
    "id": null,
    "metadata": {},
    "name": "ActionItemGroupOptionsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemGroupOptionsDeleteMutation(\n  $groupId: ID!\n) {\n  deleteCustomActionItemGroup(groupId: $groupId) {\n    deletedGroupId\n    actionItemGroups {\n      id\n      order\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed8d6938d2e7ae2ca2f69afdad765040";

export default node;
